export const LINK_PRICES = 'https://www.cian.ru/price/';

export const LINK_SELL_FAST = 'https://www.cian.ru/stati-kak-bystro-prodat-kvartiru-283715/';

export const LINK_RENT_FAST = 'https://www.cian.ru/stati-kak-sdat-kvartiru-bez-posrednikov-288643/';

export const LINK_SELL_N_RENT =
  'https://hc.cian.ru/hc/ru/articles/360058930771-%D0%9A%D0%B0%D0%BA-%D0%BE%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%BE%D0%B2%D0%B0%D1%82%D1%8C-%D0%BA%D0%BE%D0%BC%D0%BC%D0%B5%D1%80%D1%87%D0%B5%D1%81%D0%BA%D1%83%D1%8E-%D0%BD%D0%B5%D0%B4%D0%B2%D0%B8%D0%B6%D0%B8%D0%BC%D0%BE%D1%81%D1%82%D1%8C-%D0%BE%D1%82-%D1%81%D0%BE%D0%B1%D1%81%D1%82%D0%B2%D0%B5%D0%BD%D0%BD%D0%B8%D0%BA%D0%B0';

export const LINK_POCKETS = 'https://support.cian.ru/ru/knowledge_base/art/94/cat/19/#h_01FJKQ9ZCKDTER62M4724FAAS6';

export const LINK_AN_AD = 'https://cian.ru/razmestit-obyavlenie/';

export const LINK_ICALL = 'https://support.cian.ru/ru/knowledge_base/art/7760/cat/601/';

export const REVIEW_ON_CIAN =
  'https://spb.cian.ru/stati-kak-znachok-provereno-tsian-uvelichivaet-spros-na-obekty-posutochnoj-arendy-337717/';

export const SUPERHOST = 'https://promo.cian.site/superhost';

export const ONLINE_BOOKING = 'https://promo.cian.site/online_booking';

export const PLACE_AD = 'https://www.cian.ru/razmestit-obyavlenie/';

export const PIK_RENT = 'https://www.cian.ru/pik-arenda/';

export const SELECTION_REALTOR = 'https://www.cian.ru/podbor-rieltora/?cian_source=guide&cian_medium=host';

export const AESTHETIC_INTERIOR =
  'https://spb.cian.ru/stati-kak-sozdat-estetichnyj-interer-chtoby-obustroit-legko-prodat-ili-sdat-zhile-333555/?cian_source=guide&cian_medium=rent';
